import { cn } from "@ui/lib";
import type { ReactNode } from "react";
import { Prose } from "./answer";

/**
 * A guide's running text as its own section: question headings (h2) and paragraphs in one
 * reading column. The headings are the questions a buyer asks, so each one can be quoted alone.
 */
export function Article({
	children,
	tone = "white",
}: {
	children: ReactNode;
	tone?: "white" | "mist";
}) {
	return (
		<section
			className={cn(
				"mk-section",
				tone === "mist" ? "bg-(--mk-mist)" : "bg-(--mk-white)",
			)}
		>
			<div className="mk-container">
				<Prose>{children}</Prose>
			</div>
		</section>
	);
}
